<template>
  <div class="bq-product-tyzf">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      支付平台包括统一服务渠道接入、医院系统对接、统一收银台、对账服务4大功能。
    </p>
    <div class="tyzf-descs">
      <InfoBox
        :col="4"
        :itemObj="item"
        v-for="item in datalist.list"
        :key="item.advTitles"
      ></InfoBox>
    </div>
    <div :style="{ textAlign: 'center', marginBottom: '90px' }">
      <img
        src="https://img.alicdn.com/tfs/TB1nQc4E.T1gK0jSZFhXXaAtVXa-1240-802.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
        :style="{ width: '620px', height: '400px' }"
      />
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="tyzf-adv">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist.adv"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'tyzf',
  data() {
    return {
      rightArrow:
        'https://img.alicdn.com/tfs/TB1VDuoDUY1gK0jSZFMXXaWcVXa-36-16.png',
      datalist: {
        list: [
          {
            index: '1',
            advTitles: '统一服务渠道',
            advDesc:
              '接收患者从第三方应用发起的医院资金交易请求并进行处理，如自助终端、HIS收费窗口、微信公众号、支付宝服务窗、互联网医院APP等交易请求等。',
          },
          {
            index: '2',
            advTitles: '医院系统对接',
            advDesc:
              '与院内系统进行实时交互，获取患者在第三方支付平台的交易信息并写入医院HIS系统，实现内部系统患者资金的转入。',
          },
          {
            index: '3',
            advTitles: '统一收银台',
            advDesc:
              '与第三方支付渠道交互，将患者从第三方应用发起的交易请求与第三方支付渠道建立连接，实现第三方支付渠道的资金处理。',
          },
          {
            index: '4',
            advTitles: '对账服务支付平台',
            advDesc:
              '记录医院所有的交易记录，与第三方交易渠道进行交易记录的对账，与医院HIS内部的收费系统进行对账，确保财务账的准确性。',
          },
        ],
        adv: [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB16FaeF7Y2gK0jSZFgXXc5OFXa-84-86.png',
            advTitles: '支付功能',
            advDesc: '具有扫码付、移动付、医后付、聚合码支付的支付能力；',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB11cCgFYj1gK0jSZFOXXc7GpXa-84-74.png',
            advTitles: '自动对账',
            advDesc: '具有自动对账的功能，对于异常账单有预警提醒的功能。',
          },
        ],
      },
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-tyzf {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .tyzf-descs {
    margin-top: 60px;
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;

    /deep/ .bq-infobox {
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .tyzf-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 400px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    margin-bottom: 60px;
    padding-bottom: 0;
  }
}
</style>
